import ChangeCompany from "../components/ChangeCompany";

export default () => {
  return (
    <div style={{ padding: "25px" }}>
      <ChangeCompany />
    </div>
  );
};
